/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Route, Redirect, Switch } from 'react-router';
// material
import {
    Page,
    Content,
    InContentMessage,
    LoadState,
} from '@insticator/insticator-ui'; // iui-material
// pages
import RequestCommentWidget from 'pages/dashboard/commenting/requestcommentwidget/requestcommentwidget_container';
import CommentManager from 'pages/dashboard/commenting/commentmanager/commentmanager_container';
// utils
import { PrivateRoute } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/commenting_styles';



/* ========== ~~~~~~~~~~ COMMENTING ~~~~~~~~~~ ========== */
const Commenting = (props) => {

    // _getPermittedPath is used to ensure user navigates to the first permitted tab.
    // If user doesn't have permissions to see any settings they will be redirected to the 403 error page
    const requestApproved = props.requestStatus === "APPROVED";
    const permittedToRequest = () => !props.dataFetchFailed && !requestApproved;
    const permittedToManager = () => (!props.dataFetchFailed && requestApproved) || (props.mockupGenerator && props.hasCommentingUnit);

    const _getPermittedPath = () => {
        // in here we will check if user has been approved from commenting yet
        if (props.mockupGenerator) return `/dashboard/commenting/${props.hasCommentingUnit ? 'commentmanager' : 'requestwidget'}`;
        if (props.dataFetchFailed || !props.isDataReceived) {
            return `/error/403`;
        }
        if (requestApproved) {
            return '/dashboard/commenting/commentmanager';
        }
        return '/dashboard/commenting/requestwidget';
    }
    if(props.permissions.length < 1 || (props.fetchingCommentData && !props.isDataReceived)) return <Content><LoadState /></Content>; // Waits for permissions.
    return(
        <Page name={`commenting`} klass={`${props.classes.commenting}`}>
            <Content>
                <InContentMessage/>
                <Switch>
                    <Route exact path={'/dashboard/commenting'} render={() => <Redirect to={_getPermittedPath()} />} />
                    <PrivateRoute permitted={permittedToRequest()} redirectTo={_getPermittedPath()} path={'/dashboard/commenting/requestwidget'} component={RequestCommentWidget} />
                    <PrivateRoute permitted={permittedToManager()} redirectTo={_getPermittedPath()} path={'/dashboard/commenting/commentmanager'} component={CommentManager} />
                    <Redirect to='/error/404' />
                </Switch>
            </Content>
        </Page>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Commenting);
